$( document ).ready(function() {

  setTimeout(function() {
    AOS.init();
  }, 1000);

  setTimeout(function() {

      if(window.innerWidth < 769){
        var varint_scll_size = 30;
      }
      else {
        var varint_scll_size = 58;
      }
    
      // duration of scroll animation
      var scrollDuration = 300;
      // paddles
      var leftPaddle = document.getElementsByClassName('left-paddle');
      var rightPaddle = document.getElementsByClassName('right-paddle');
      // get items dimensions
      var itemsLength = $('.swt-item').length;    
      var itemSize = $('.swt-item').outerWidth(true);
    
      // get some relevant size for the paddle triggering point
      var paddleMargin = 5;
      
      // get wrapper width
      var getMenuWrapperSize = function() {
        return $('.product-card__aside').outerWidth();
      }
      var menuWrapperSize = getMenuWrapperSize();
    
      // the wrapper is responsive
      $(window).on('resize', function() {
        menuWrapperSize = getMenuWrapperSize();
      });
      // size of the visible part of the menu is equal as the wrapper size 
      var menuVisibleSize = menuWrapperSize;
      
      // get total width of all menu items
      var getMenuSize = function() {
        return itemsLength * itemSize;
      };
      var menuSize = getMenuSize();
    
      // get how much of menu is invisible
      var menuInvisibleSize = menuSize - menuWrapperSize;

      function varint_scroll_pos_func(varint_main_elemnt) {
        varint_main_elemnt.on('scroll', function(scroll_e) {
  
          // get how much have we scrolled so far
          var menuPosition = $(this).scrollLeft();
          // get how much of menu is invisible
          menuInvisibleSize = menuSize - menuWrapperSize;
          var menuEndOffset = menuInvisibleSize - paddleMargin;
          
          if (menuPosition <= paddleMargin) {
            $(this).parent().find('.left-paddle').addClass('hidden');
            $(this).parent().find('.right-paddle').removeClass('hidden');
          } else if (menuPosition < menuEndOffset) {
            // show both paddles in the middle
            $(this).parent().find('.left-paddle').removeClass('hidden');
            $(this).parent().find('.right-paddle').removeClass('hidden');
          } else if (menuPosition >= menuEndOffset) {
            $(this).parent().find('.left-paddle').removeClass('hidden');
            $(this).parent().find('.right-paddle').addClass('hidden');
          }
          
        });
        
      }
      
      // scroll to left
      $(rightPaddle).on('click', function() {
        var scroll_main_div_selector = $(this).parent().parent().find('.product-card__aside');
        var new_scrollpos = scroll_main_div_selector.animate({
          scrollLeft:  '+='+varint_scll_size
          //scrollLeft: getMenuPosition() + 58
        }, scrollDuration);

        varint_scroll_pos_func(scroll_main_div_selector);
      });
      
      // scroll to right
      $(leftPaddle).on('click', function() {
        var scroll_main_div_selector = $(this).parent().parent().find('.product-card__aside');
        var new_scrollpos = scroll_main_div_selector.animate({
          scrollLeft: '-='+varint_scll_size
          //scrollLeft: getMenuPosition() - 58
        }, scrollDuration);

        varint_scroll_pos_func(scroll_main_div_selector);
      });
    
      $('.product-info__complementary-products .horizontal-product-list').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        prevArrow:'<div class="slick-prev pull-left"><img src="https://cdn.shopify.com/s/files/1/0667/8950/7365/files/arrow-prev.svg?v=1672122065" /></div>',
        nextArrow:'<div class="slick-next pull-right"><img src="https://cdn.shopify.com/s/files/1/0667/8950/7365/files/arrow-next.svg?v=1672122065" /></div>'
      });

      if(window.innerWidth < 769){
        $('.prod-collection-list .floating-controls-container .collection-list, .shopify-section--product-recommendations .scrollable-with-controls .scroll-area .product-list').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        });

        $('#about-desk-video').remove();        
      }
      else {
        $('#about-mob-video').remove();
      }
    
  }, 2000); 

  // $('.prod-img-text-slider .media-with-text .media-with-text__media').slick({
  //   infinite: false,
  //   dots: true,
  //   slidesToShow: 2,
  //   slidesToScroll: 1,
  //   prevArrow:'<button class="slick-prev slick-arrow slick-disabled" aria-label="Previous" type="button" aria-disabled="true"><span class="animated-arrow animated-arrow--reverse"></span></button>',
  //   nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" aria-disabled="false"><span class="animated-arrow"></span></button>'
  // });

    $('.prod-img-text-slider .media-with-text .media-with-text__media').slick({
    infinite: false,
    dots: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow:'<button class="slick-prev slick-arrow slick-disabled" aria-label="Previous" type="button" aria-disabled="true"><span class="animated-arrow animated-arrow--reverse"></span></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" aria-disabled="false"><span class="animated-arrow"></span></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  
    $('.index-section.featured-blog-slider ul').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrow:true,
    centerMode: false,  
    nextArrow: '<i class="fa fa-chevron-right"></i>',
    prevArrow: '<i class="fa fa-chevron-left"></i>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: true
        }
      }
    ]
  }); 
  

  $('.slidershow2-with-slick').slick({
    infinite: false,
    autoplay: true,
    autoplaySpeed: 6000,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false    
  });

 $('.slidershow2-with-slick').on('beforeChange', function() {
      $('.slider-aos-anim').removeClass("aos-animate");
  })
  .on('afterChange', function(event, slick, currentSlide) {
      $('.slider-aos-anim').addClass("aos-animate");
  });

  
  var rv_slick = $('.review-slider-wrap .review-slider-box.rsb-wrap1').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    draggable: false,
    variableWidth: true,
    speed: 3000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear', 
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  var rv_slick2 = $('.review-slider-wrap .review-slider-box.rsb-wrap2').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    draggable: false,
    variableWidth: true,
    speed: 3000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    rtl: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  /*$('.slick-next').on('click', function () {
      slick.slick('slickNext');
  });
  $('.slick-prev').on('click', function () {
      slick.slick('slickPrev');
  });
  slick.hover(function() {
    slick.slick('slickPause');
  }, function() {
    slick.slick('slickPlay');
  });*/

  $('.index-section.featured-blog-slider ul').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrow:true,
    nextArrow: '<i class="fa fa-chevron-right"></i>',
    prevArrow: '<i class="fa fa-chevron-left"></i>',
  }); 

  $('body').on('click', '.acc-show-more-btn', function() {
      $('.product-faqs .section-stack__main .accordion-box .accordion-column.accordion-right').toggleClass('acc-mobile-hide');
      if ($(this).find('span').text() == "Find out more") {
        $(this).find('span').text('Show less');
      } else {
        $(this).find('span').text('Find out more');
      }
  });
  
 if(window.innerWidth < 769){
    var maxheight = 70;
    $(".mob-read-more-box").each(function(){
      var cont_height = $(this).children().height();
      if(cont_height > maxheight){
        $(this).addClass('active-read-more');
      }      
    });

    $('body').on('click', '.read-more-btn', function() {
        $(this).parent().toggleClass('autoheight');
        if ($(this).text() == 'Read More') {
          $(this).text('Read Less');
        }
        else {
          $(this).text('Read More');
        }
    });
    
  }

  if(window.innerWidth < 767){
    $('.shopify-section--media--slider.shopify-section--new--collection--slider .collection-list-new .image-link-blocks').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
      nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>"
    });

    $('.why-buy-from-us .text-with-icons__list').slick({
      infinite: false,
      slidesToShow: 1.5,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      infinite: true,
      prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
      nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>"

     });




    
  
  }

  setTimeout(function() {
      $('.banner-animated-wrap .main-heading').addClass('border-animate-start');
  }, 1000);
  
  AOS.refresh();
});

function currencyFormSubmit(event) {
  event.target.form.submit();
}

document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
  element.addEventListener('change', currencyFormSubmit);
});



let player, vm_player;

// Function to open the custom popup and play the video
function cstopenPopup(videoUrl, videotype) {
    document.getElementById("customPopup").style.display = "block";

    if (videotype == "youtube") {
      document.getElementById('cst-player').classList.remove('hidden');
      document.getElementById('cst-player-self').classList.add('hidden');
      
      if (player) {
        player.loadVideoById(videoUrl);
      } else {
          player = new YT.Player('cst-player', {
              height: '360',
              width: '640',
              videoId: videoUrl,
              playerVars: {
                  'autoplay': 1, // Autoplay the video
                  'controls': 0, // Hide video controls
                  'modestbranding': 1, // Prevent YouTube logo
                  'rel': 0 // Hide related videos
              },
              events: {
                  'onReady': function (event) {
                      event.target.playVideo(); // Autoplay the video when ready
                  }
              }
          });
      }
    }
    if (videotype == "vimeo") {
      document.getElementById('cst-player').classList.remove('hidden');
      document.getElementById('cst-player-self').classList.add('hidden');
      
      if (vm_player) {
        vm_player.play(videoUrl);
      } else {
        vm_player = new Vimeo.Player('cst-player', {
          id: videoUrl, // Replace with your Vimeo video ID
          autoplay: true,
          controls: false,
          title: false
        });
      }
    }
    if (videotype == "mp4") {
      document.getElementById('cst-player').classList.add('hidden');
      document.getElementById('cst-player-self').classList.remove('hidden');
      
      var pop_videotag = document.getElementById('videoPlayer');
      var pop_videotag_src = document.getElementById('videoPlayersource');      
      pop_videotag_src.setAttribute('src', videoUrl);
      pop_videotag.load();
      pop_videotag.play();
    }
    
}

// Function to close the custom popup and stop the video
 function cstclosePopup() {
    document.getElementById("customPopup").style.display = "none";
    if (player) {
      player.stopVideo();
    }
    if (vm_player) {
      vm_player.pause();
    }    
    document.getElementById("videoPlayer").pause();
}

// Open popup buttons click event
const video_pop_btns = document.querySelectorAll('.video-pop-btn');
video_pop_btns.forEach(function(button) {
    button.addEventListener('click', function() {
        const videoUrl = button.getAttribute('data-video-id');
        const videotype = button.getAttribute('data-video-type');
        cstopenPopup(videoUrl, videotype);
    });
});

// Close popup button click event
document.getElementById('closePopupButton').addEventListener('click', function() {
    cstclosePopup();
});

document.addEventListener("DOMContentLoaded", function () {
    const imageBanners = document.querySelectorAll("image-banner");

    imageBanners.forEach(function (banner) {
        if (banner.querySelector("video-media")) {
            banner.classList.add("video-media");
        }
    });
});



